/**
 * Process exit codes for Kyro CI mode.
 *
 * 0 = Success             — all thresholds passed
 * 1 = Critical Errors     — one or more error-severity issues
 * 2 = Warning Limit       — warning count exceeds maxWarnings threshold
 * 3 = Invalid Config      — project configuration is invalid / missing
 * 4 = Internal Error      — unexpected runtime error during analysis
 */
export const ExitCode = {
  SUCCESS: 0,
  CRITICAL_ERRORS: 1,
  WARNING_LIMIT: 2,
  INVALID_CONFIG: 3,
  INTERNAL_ERROR: 4,
} as const;

export type ExitCodeValue = (typeof ExitCode)[keyof typeof ExitCode];

export type ExitReason =
  | "success"
  | "critical_errors"
  | "warning_limit"
  | "invalid_config"
  | "internal_error";

/**
 * Maps a named reason to its numeric exit code.
 */
export function resolveExitCode(reason: ExitReason): ExitCodeValue {
  switch (reason) {
    case "success":
      return ExitCode.SUCCESS;
    case "critical_errors":
      return ExitCode.CRITICAL_ERRORS;
    case "warning_limit":
      return ExitCode.WARNING_LIMIT;
    case "invalid_config":
      return ExitCode.INVALID_CONFIG;
    case "internal_error":
      return ExitCode.INTERNAL_ERROR;
  }
}
